export {
  transformCoordinates,
  multiply3x3,
  multiply3x1,
  getConnectionOffset,
  calculatePositions,
  _orderConnections,
  IDENTITY_MATRIX,
};

// export to a buffer with utf-8 encoding.
// export function toBuffer(circuitSVG) {
//   var buf = Buffer.from(circuitSVG, 'utf-8');
//   return buf;
// }
const IDENTITY_MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];

function multiply3x3(a, b) {
  // Multiply each row by matrixA
  let result0 = multiply3x1(a, [b[0], b[1], b[2]]);
  let result1 = multiply3x1(a, [b[3], b[4], b[5]]);
  let result2 = multiply3x1(a, [b[6], b[7], b[8]]);
  return [result0[0], result0[1], result0[2], result1[0], result1[1], result1[2], result2[0], result2[1], result2[2]];
}

function multiply3x1(matrix, [x, y, z]) {
  return [
    x * matrix[0] + y * matrix[1] + z * matrix[2],
    x * matrix[3] + y * matrix[4] + z * matrix[5],
    x * matrix[6] + y * matrix[7] + z * matrix[8],
  ];
}

function transformCoordinates([x, y], matrices) {
  let coords = [x, y, 1];
  for (let matrix of matrices) {
    coords = multiply3x1(matrix, coords);
  }
  return [coords[0], coords[1]];
}

function getConnectionOffset(connection, circuitsWithMetadata) {
  let fromConnectionPoint = circuitsWithMetadata[connection.fromCircuit].metadata.connectionPoints.find((cp) => {
    return cp.type === 'primary-out' && cp.name === connection.fromOutput;
  });
  let toConnectionPoint = circuitsWithMetadata[connection.toCircuit].metadata.connectionPoints.find((cp) => {
    return cp.type === 'primary-in' && cp.name === connection.toInput;
  });
  return {
    x: fromConnectionPoint.position[0] - toConnectionPoint.position[0],
    y: fromConnectionPoint.position[1] - toConnectionPoint.position[1],
  };
}

function calculatePositions(connections, offsets, circuitCount) {
  let orderedConnections = _orderConnections(connections, offsets);
  // Seed the positions with an initial position of [0,0] - the rest should follow

  let positions = [];
  for (let i = 0; i < circuitCount; i++) positions.push(undefined);

  if (orderedConnections[0].reverse) {
    positions[orderedConnections[0].toCircuit] = { x: 0, y: 0 };
  } else {
    positions[orderedConnections[0].fromCircuit] = { x: 0, y: 0 };
  }
  for (let connIndex = 0; connIndex < orderedConnections.length; connIndex++) {
    let conn = orderedConnections[connIndex];
    if (conn.reverse) {
      // ToCircuit already placed - apply offsets in reverse
      let newPosition = {
        x: positions[conn.toCircuit].x - conn.offset.x,
        y: positions[conn.toCircuit].y - conn.offset.y,
      };
      if (!positions[conn.fromCircuit]) {
        positions[conn.fromCircuit] = newPosition;
      } else if (positions[conn.fromCircuit].x != newPosition.x || positions[conn.fromCircuit].y != newPosition.y) {
        throw 'Circuits in meshes with inconsistent connection point positions cannot be placed';
      }
    } else {
      // FromCircuit already placed - apply offsets as calculated
      let newPosition = {
        x: positions[conn.fromCircuit].x + conn.offset.x,
        y: positions[conn.fromCircuit].y + conn.offset.y,
      };
      if (!positions[conn.toCircuit]) {
        positions[conn.toCircuit] = newPosition;
      } else if (positions[conn.toCircuit].x !== newPosition.x || positions[conn.toCircuit].y !== newPosition.y) {
        throw 'Circuits in meshes with inconsistent connection point positions cannot be placed';
      }
    }
  }
  return positions;
}

function _orderConnections(connections, offsets) {
  let orderCount = 0;
  let orderedConnections = connections.map((connection, index) =>
    Object.assign({ offset: offsets[index] }, connection)
  ); //shallow clone with offset
  // Seed the loop with the first connection, regardless of topology
  let toProcess = [0];
  orderedConnections[0]['ordered'] = orderCount++;
  orderedConnections[0]['reverse'] = false;
  while (toProcess.length > 0) {
    let processing = toProcess;
    toProcess = [];
    // find unprocessed connections adjacent to each connection processed so far
    for (let connectionIndex of processing) {
      orderedConnections.forEach((connection, index) => {
        if (
          !('ordered' in connection) &&
          (connection.fromCircuit === connections[connectionIndex].toCircuit ||
            connection.toCircuit === connections[connectionIndex].fromCircuit)
        ) {
          toProcess.push(index);
          connection['ordered'] = orderCount;
          connection['reverse'] = connection.toCircuit === connections[connectionIndex].fromCircuit;
          orderCount++;
        }
      });
    }
  }
  if (orderCount < connections.length) {
    throw 'Circuits that do not form a single island of connection cannot be placed';
  }
  orderedConnections.sort((a, b) => {
    return a.ordered - b.ordered;
  });
  return orderedConnections;
}
